/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
//import Bing from '../../actions/ReeferMap.js';
//import * as ReeferMapjs from '../../actions/ReeferMap.js';
//var Bing = ReeferMapjs.default;
import ReeferCallout from '../../actions/ReeferCallout';
import $, { param } from 'jquery';
import Formatters from '../../actions/Formatters';
import { GensetCellRender } from '../../actions/GensetCellRender';
import GensetFormatters from '../../actions/GensetFormatter';
//import * as moment from 'moment';
import moment from 'moment';
import DateFormat from 'dateformat';
import { RCUtils } from './../../RCUtils';
import 'ag-grid-enterprise';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker';
//import "../../../node_modules/bootstrap/dist/css/bootstrap.css";
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridGensetHistoryToolBar } from '../sharedcomponents/GridGensetHistoryToolBar';
import { GensetStatusGrid } from './GensetStatusGrid';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
import { ReeferMap } from '../childcomponents/ReeferMap';
import lodashfilter from 'lodash/filter';
var Config: any = require('../../Config.json');

interface GensetHistoryGridState {
    loading: boolean;
    rowData: server.GensetHistoryUI[];
    Filters: GensetHistoryFilter;
    columnDefs: any[];
    overlayLoadingTemplate: any;
    pageSize: any;
    gridApiParams: any;
    reeferFormatter: server.ReeferFormatter;
    buttonState: boolean;
    PreferenceDTTM: any;
    //buttonSearchHtml: any;
    defaultColDef: any[];
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
    selectedDataItems: any[];
}
var self;
var coppiedData;
var coppiedDataWithHeader;
var functionId;
var columnDefs2: any[];
var columnDefs: any[];
var isMapEnable: boolean;
var gensetAssetSensors: any[];

export class GensetHistoryGrid extends React.Component<any, GensetHistoryGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = this.initHistoryFilters();//new GensetHistoryFilter();
        functionId = 47; // functionId for GensetHistory Grid

        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        this.state = {
            loading: true,
            rowData: [],
            columnDefs: [],
            overlayLoadingTemplate: overlayTemplate,
            Filters: filterSet,
            pageSize: 25,
            gridApiParams: [],
            reeferFormatter: this.props.propsReeferFormatterData,
            buttonState: false,
            PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
            defaultColDef: [],
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            autoGroupColumnDef: { minWidth: 200 },
            selectedDataItems: []
        };

        //var columnDefs = this.createColumnDefs();
        self = this;
        //var filterParams = JSON.stringify(this.state.Filters);
        //if (this.state.reeferFormatter === null) {
        //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //    fetch(request)
        //        .then(RCUtils.handleError)
        //        .then(response => response.json() as Promise<server.ReeferFormatter>)
        //        .then(data => {
        //            this.setState({
        //                reeferFormatter: data
        //            }, () => {
        //                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //                fetch(request)
        //                    .then(RCUtils.handleError)
        //                    .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
        //                    .then(data => {
        //                        this.setState({
        //                            rowData: data,
        //                            loading: false
        //                        });
        //                    });
        //            });
        //        });
        //}
        //else {
        //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //    fetch(request)
        //        .then(RCUtils.handleError)
        //        .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
        //        .then(data => {
        //            this.setState({
        //                rowData: data,
        //                loading: false
        //            });
        //        });
        //}

    }

    initHistoryFilters() {
        var gensetHistoryFilter = new GensetHistoryFilter();
        gensetHistoryFilter.AssetNumber = '';
        gensetHistoryFilter.DeviceNumber = '';
        gensetHistoryFilter.EventCode = '';
        gensetHistoryFilter.FromDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');
        gensetHistoryFilter.ToDate = DateFormat(new Date(), 'mm/dd/yyyy HH:MM');

        return gensetHistoryFilter;
    }
    renderCustomerDeviceTypeSensorColumns() {
        columnDefs = this.createColumnDefs();
        var newColumns = columnDefs;
        //columnDefs2 = columnDefs;
        var generatedColumns = [];
        if (this.props.customerDeviceTypeSensor != null && this.props.customerDeviceTypeSensor != undefined)
            gensetAssetSensors = this.props.customerDeviceTypeSensor.filter(x => x.AssetTypeCd == 'G');

        if (gensetAssetSensors != null && gensetAssetSensors != undefined && gensetAssetSensors.length > 0) {
            $.each(gensetAssetSensors, function (i, val) {
                var customerDeviceTypeSensorObject: any;
                if (val.SensorTypeCd.trim() == "T")
                    customerDeviceTypeSensorObject = { headerName: '', field: '', headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, headerValueGetter: Formatters.TempSensorHeaderFormatter, valueGetter: Formatters.stringTypeSortingForSensorfields, cellRenderer: Formatters.TemperatureSensorValueFormatter, width: 130 };
                else
                    customerDeviceTypeSensorObject = { headerName: '', field: '', refData: val.SensorSetDsc + "," + val.SensorResetDsc, headerClass: val.OORText, enableRowGroup: true, sortable: true, resizable: true, valueGetter: Formatters.stringTypeSortingForDigitalSensorfields, cellRenderer: Formatters.DigitalSensorFormatter, width: 130 };

                //var fieldName = val.FieldValue;
                var columnHeaderName = val.ColumnNm;
                var columnFieldName = val.FieldName + "_" + val.DeviceTypeCd.trim();
                customerDeviceTypeSensorObject.headerName = columnHeaderName;
                customerDeviceTypeSensorObject.field = columnFieldName;
                generatedColumns.push(customerDeviceTypeSensorObject);
            });

            var newColumnDefination = {
                headerName: "Device Sensor(s)",
                children: generatedColumns
            };
            if (!newColumns.some(x => x.headerName === "Device Sensor(s)"))
                newColumns.push(newColumnDefination);
            this.setState({ columnDefs: newColumns });

            if (!columnDefs2.some(x => x.headerName === "Device Sensor(s)"))
                columnDefs2.push(newColumnDefination);// = newColumns;
        }
        else {
            this.setState({ columnDefs: columnDefs });
        }
    }

    componentDidMount() {
        //var columnDefs = this.createColumnDefs();
        columnDefs2 = this.createColumnDefs();
        //this.setState({ columnDefs: columnDefs });
        setTimeout(() => {
            this.renderCustomerDeviceTypeSensorColumns();
        }, 1000);






        this.renderDateFields();
        self.enableDisableSearchButton(false);
    }

    onGridReady(params: any) {
        //params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 13);
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        //GridPreferenceControl.HistoryGridPreferenceColumns(functionId, params.api, "GensetHistoryGrid");
        setTimeout(() => {
            GridColumnPreferences.HistoryGridPreferenceColumns(functionId, params.api, gridPreferencesData, "GensetHistoryGrid");
        }, 3000);
    }
    
    static refreshGridReady(dashboardWidgetsSearch: any){
        var gridPreferencesData: any = dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 13);
        var defaultColumns = self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        setTimeout(() => {
            GridColumnPreferences.HistoryGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "GensetHistoryGrid");
        }, 3000);       
    }

    //WI 26721
    static GetGensetHistoryGridPrefColumns(gridPreferencesData: any) {
        //var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 13);
        GridColumnPreferences.HistoryGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "GensetHistoryGrid");
    }

    //renderEmailDialog(gridData: any, colDefs: any, formName: string, parentChild: string) {
    //    this.props.renderDataToEmailControl(gridData, colDefs, formName, parentChild);
    //}

    refreshGrid = () => {
        $('#globalLoader').show();
        var filterParams = JSON.stringify(this.state.Filters);
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
            .then(data => {
                isMapEnable = self.props.mapEnabled;
                if (data.length > 0 && isMapEnable) {
                    ReeferCallout.BindGensetTracePushpins(data, 'gensetTrace');
                    var dataArray = [];
                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                        dataArray.push(self.state.selectedDataItems[0]);
                    else
                        dataArray.push(data[0]);
                    self.BindMapPushPin(dataArray);
                }
                this.setState({
                    rowData: data
                }, () => { $('#globalLoader').hide(); });

                self.state.gridApiParams.paginationGoToFirstPage();
                self.state.gridApiParams.hideOverlay();
                //$("#globalLoader").hide();
            });
    };

    onCellClickedCopy(event) {
        coppiedDataWithHeader = event.colDef.headerName + " \r\n" + event.value;
        coppiedData = event.value;

        if (event.data != null && event.data != undefined) {
            self.props.getLastSelectedRow(event.data);
            // $('#globalLoader').show();
        }
    }

    static ApplyGensetHistorySearch(params: any, isFromMap: boolean, isHistoryEnabled: boolean) {
        $('#globalLoader').show();
        this.ClearHistoryGridData();
        if (self != undefined && isHistoryEnabled) {
            isMapEnable = self.props.mapEnabled;
            self.state.gridApiParams.showLoadingOverlay();
            self.setState({ loading: true });
            self.enableDisableSearchButton(true);
            if (params.EventDTTM != null && params.EventDTTM != "") {
                var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
                var currenttoDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
                var toDTTM = Formatters.DateTimeFormatter(params.EventDTTM);
                var modifiedDttm = new Date(toDTTM);
                modifiedDttm.setDate(modifiedDttm.getDate() - 1);
                var fromDTTM = DateFormat(new Date(modifiedDttm.toString()), 'mm/dd/yyyy');
                var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
                var toDate = moment(new Date(currenttoDTTM)).endOf('day').toString();
                self.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
                self.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            }
            else {
                var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
                var toDTTM = Formatters.DateTimeFormatter(currentUtcDttm);
                var modifiedDttm = new Date(toDTTM);
                modifiedDttm.setDate(modifiedDttm.getDate() - 1);
                var fromDTTM = DateFormat(new Date(modifiedDttm.toString()), 'mm/dd/yyyy');
                var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
                var toDate = moment(new Date(toDTTM)).endOf('day').toString();
                self.state.Filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
                self.state.Filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            }

            self.state.Filters.AssetNumber = params.AssetMasterID;
            self.state.Filters.DeviceNumber = params.RCDID;
            self.state.Filters.EventCode = params.EventCD;
            var filterParams = JSON.stringify(self.state.HistoryFilters);

            var filterParams = JSON.stringify(self.state.Filters);
            //if (self.state.reeferFormatter === null) {
            //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //    fetch(request)
            //        .then(RCUtils.handleError)
            //        .then(response => response.json() as Promise<server.ReeferFormatter>)
            //        .then(data => {
            //            self.setState({
            //                reeferFormatter: data
            //            }, () => {
            //                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            //                fetch(request)
            //                    .then(RCUtils.handleError)
            //                    .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
            //                    .then(data => {
            //                        self.state.gridApiParams.hideOverlay();
            //                        self.setState({
            //                            rowData: data,
            //                            loading: false
            //                        });

            //                        if (data.length > 0 && isMapEnable)
            //                            ReeferCallout.BindGensetTracePushpins(data, 'gensetTrace');
            //                        else
            //                            $('#globalLoader').hide();

            //                        self.props.gensetIdForHeader(params.AssetNumber);
            //                        if (isFromMap)
            //                            GensetStatusGrid.SelectCurrentNode(params.AssetNumber);
            //                    });
            //            });
            //        });
            //}
            //else {
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
                .then(data => {
                    self.state.gridApiParams.hideOverlay();
                    self.setState({
                        rowData: data,
                        loading: false
                    });

                    if (data.length > 0 && isMapEnable) {
                        GensetStatusGrid.validateGensetStatusHistoryMismatch(params.EventDTTM, data[0].EventDTTM);//WI 26971
                        ReeferCallout.BindGensetTracePushpins(data, 'gensetTrace');
                        var dataArray = [];
                        if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                            dataArray.push(self.state.selectedDataItems[0]);
                        else
                            dataArray.push(data[0]);
                        self.BindMapPushPin(dataArray);
                    }
                    else
                        $('#globalLoader').hide();

                    self.props.gensetIdForHeader(params.AssetNumber);
                    if (isFromMap)
                        GensetStatusGrid.SelectCurrentNode(params.AssetNumber);
                });
            //}
        }
        else {
            $('#globalLoader').hide();
        }
    }

    static ClearHistoryGridData() {
        if (self != undefined) {
            self.setState({
                rowData: [],
                loading: false
            });

            //self.enableDisableSearchButton(false);
        }
    }

    static refreshDataGrid() {
        self.setState({
            rowData: self.state.rowData
        });
    };

    enableDisableSearchButton(isEnable: any) {
        if (isEnable) {
            this.setState({ buttonState: true });
        }
        else {
            this.setState({ buttonState: false });
        }
    }

    copyToClipboard(text) {
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    ProcessCellForClipboard(params) {
        return Formatters.CopyCommandFormatters(params);
    }

    copyRowsToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: false });//RCNG-225
    }

    copyRowsWithHeadersToClipBoard() {
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.copySelectedRowsToClipboard({ includeHeaders: true });//RCNG-225
    }

    getGensetHistoryContextMenuItems = params => {
        if (params != null && params != undefined && params.node != null && params.node != undefined && !params.node.group) {
            var selectflag = false;
            var selectedCell = params.api.getFocusedCell();
            var selectedRowIndex = selectedCell.rowIndex;
            var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
            if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
                var currentRowId = currentRow.id;
                //   coppiedData = params.value;
                var selectedrowNode = params.api.getRowNode(currentRowId);
                var gensetHistoryID = selectedrowNode.data.GensetHistoryID;
                params.api.forEachLeafNode((newRowNode, index) => {
                    if ((newRowNode.data.GensetHistoryID === gensetHistoryID)) {
                        selectedrowNode = newRowNode;
                        return false;
                    }
                });
                $.each(self.state.selectedItems, (index, item) => {
                    if (item.GensetHistoryID == selectedrowNode.data.GensetHistoryID) {
                        selectflag = true;
                        return false;
                    }
                });
                if (!selectflag)
                    params.api.deselectAll();
                selectedrowNode.setSelected(true);
            }
            var result = [
                {
                    name: 'Copy',
                    subMenu: [
                        {
                            name: 'Copy Cell',
                            action: () => {
                                //this.reeferContextMenuClick("Copy");
                                var cellContent = this.ProcessCellForClipboard(params);
                                params.api.clipboardService.copyDataToClipboard(cellContent);

                            }
                        },
                        {
                            name: 'Copy Row(s)',
                            action: () => {
                                this.copyRowsToClipBoard();
                            }
                        },
                        {
                            name: 'Copy Row(s) with Headers',
                            action: () => {
                                this.copyRowsWithHeadersToClipBoard();
                            }
                        },
                    ],
                },
            ];
            return result;
        }
    };

    createColumnDefs() {
        return [
            {
                headerName: 'Group',
                minWidth: 210,
                hide: true
            },
            {
                headerName: 'State Indicators',
                children: [
                    //{ headerName: "CC", field: "CCSeverityLevelGenset", width: 65, cellRenderer: Formatters.stringTypeFormatter },
                    {
                        headerName: "SW", field: "IgnitionOn", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 65,
                        filterParams: { valueGetter: params => { return GensetFormatters.gensetSwitchFormatterImgForFilter(params); } },
                        valueGetter: (params) => { return GensetFormatters.gensetSwitchSorting(params); }, cellRenderer: GensetCellRender.gensetSwitchFormatterImg
                    },
                    {
                        headerName: "ENG", field: "GensetRunning", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return GensetFormatters.gensetRunningFormatterForFilter(params); } },
                        valueGetter: (params) => { return GensetFormatters.EngineSorting(params); }, width: 65, cellRenderer: GensetCellRender.gensetRunningFormatter
                    },
                    {
                        headerName: "VSL", field: "VesselCd", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, width: 80,
                        valueGetter: (params) => { return Formatters.vesselCdSorting(params); }, cellRenderer: GensetCellRender.stringTypeValueFormatter
                    },
                    { headerName: "INV", field: "AssetState", enableRowGroup: true, columnGroupShow: 'open', cellClass: 'myExcelStyle', filter: true, sortable: true, resizable: true, width: 80, valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "AssetState"); }, cellRenderer: GensetCellRender.AssetStateFormatter }
                    //,{ headerName: "ALRT", field: "AlertSeverityID", width: 65, cellRenderer: (params) => { return Formatters.statusIndicatorWithDescriptionForALR(params, self.state.reeferFormatter.AlertMasterList); } }
                ]
            },
            {
                headerName: 'Latest Event',
                children: [
                    {
                        headerName: "OEM", field: "OEMTypeCD", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 130,
                        filterParams: { valueGetter: params => { return GensetFormatters.oemTypeFormatterGensetForFilter(params); } },
                        valueGetter: params => { if (params.data != null && params.data != undefined) return Formatters.OEMTypeValueFormatter(params.data.OEMTypeCD); }
                    },
                    {
                        headerName: "Genset ID", field: "AssetNumber", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 150,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.AssetNumber); }, cellRenderer: GensetCellRender.stringTypeValueFormatter
                    },
                    {
                        headerName: "Event", field: "EventDescription", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        cellRenderer: GensetCellRender.stringTypeFormatter, width: 150
                    },
                    {
                        headerName: "Event time", field: "EventDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        headerValueGetter: Formatters.TimeZoneHeaderFormatter, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterEventDTTMForFilter(params); } },
                        cellRenderer: Formatters.dateTypeFormatter, width: 150
                    }
                ]
            },
            {
                headerName: 'Last Reported Genset and Device Data',
                children: [
                    {
                        headerName: "Device fence", field: "FenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FenceName); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "Server fence", field: "BackendGeofenceName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.BackendGeofenceName); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    //{ headerName: "Region Fence", field: "RegionGeofenceName", cellRenderer: Formatters.stringTypeFormatter, width: 150 },
                    {
                        headerName: "Device fence ID", field: "FenceNameID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FenceNameID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "Server fence ID", field: "BackendGeofenceNameID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.BackendGeofenceNameID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    //{ headerName: "Region Fence ID", field: "RegionGeofenceNameID", cellRenderer: Formatters.stringTypeFormatter, columnGroupShow: 'open', width: 150 },
                    {
                        headerName: "Geofence revision", field: "GeofenceDefinitionRevision", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.floatTypeSorting(params.data.GeofenceDefinitionRevision); }, cellRenderer: GensetCellRender.floatTypeValueFormatter, width: 150
                    },
                    {// RcNG 1257
                        headerName: "Address", field: "Address", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.stringTypeSortingFieldName(params, "Address"); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, columnGroupShow: 'open', width: 150
                    },
                    {
                        headerName: "City", field: "City", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.City); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140
                    },
                    {
                        headerName: "State", field: "State", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.State); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140
                    },
                    {
                        headerName: "Country", field: "Country", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.Country); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "Zip", field: "ZipCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ZipCode); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 100
                    },
                    {
                        headerName: "Battery (V)", field: "ExtBattVoltage", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.BattVoltageSorting(params.data.ExtBattVoltage); }, cellRenderer: Formatters.BattVoltageValueFormatter,
                        filterParams: { valueGetter: params => { return Formatters.BattVoltageFormatterForFilter(params); } }, width: 150
                    },
                    //{ headerName: "Alerts", field: "Alerts", cellRenderer: (params) => { return Formatters.AlertDescriptionFormatter(params, self.state.reeferFormatter.AlertMasterList); }, width: 150 },
                    {
                        headerName: "Fuel sensor", field: "HasFuelSensor", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return GensetFormatters.fuelSensorTrace(params); } },
                        valueGetter: (params) => { return GensetFormatters.FuelSensorSorting(params); }, cellRenderer: GensetFormatters.fuelSensorTrace, width: 120, getQuickFilterText: GensetFormatters.FuelSensorQuickFilterFormatter
                    },
                    {
                        headerName: "Fuel level (gal.)", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return GensetFormatters.fillLevelGalTrace(params); } },
                        valueGetter: (params) => { return GensetFormatters.FuelLevelGalSorting(params); }, field: "FuelLevel", cellRenderer: GensetFormatters.fillLevelGalTrace, width: 120, getQuickFilterText: GensetFormatters.FuelLevelGalQuickFilterFormatter
                    },
                    {
                        headerName: "Fuel level", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, valueGetter: (params) => { return GensetFormatters.FuelLevelSorting(params); },
                        field: "FractionDisplay", cellRenderer: GensetCellRender.fillLevelTrace, width: 100, getQuickFilterText: GensetCellRender.FuelLevelQuickFilterFormatter
                    },
                    {
                        headerName: "Reefer ID", field: "ReeferID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 140,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter
                    },
                    {
                        headerName: "Reefer state", field: "ReeferStateDsc", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferStateDsc); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140
                    },
                    {
                        headerName: "Uses LOP", field: "HasOilPressureSwitch", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return GensetFormatters.YesNoConverterForFilter(params); } }, valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.YesNoValueSorting(params.data.HasOilPressureSwitch); }, width: 120
                    },
                    {
                        headerName: "Model", field: "ModelType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 120,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ModelType); }, cellRenderer: GensetCellRender.stringTypeValueFormatter
                    },
                    //{ headerName: "Cust. Model", field: "ModelNumber", width: 120, cellRenderer: Formatters.stringTypeFormatter },
                    {
                        headerName: "Form", field: "FormType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 120,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FormType); }, cellRenderer: GensetCellRender.stringTypeValueFormatter
                    },
                    {
                        headerName: "Tank sz (gal)", field: "GensetTankSize", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 120,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.GensetTankSize); }, cellRenderer: GensetCellRender.stringTypeValueFormatter
                    },
                    {
                        headerName: "Loc coords", field: "GPSCoords", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { return Formatters.GPSCoordsSorting(params); }, filterParams: { valueGetter: params => { return Formatters.GPSCoordsForFilter(params); } }, cellRenderer: GensetCellRender.GPSCoordsFormatter, width: 150
                    },
                    {
                        headerName: "Loc age (h:m:s)", field: "GPSLastLock", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); } },
                        valueGetter: params => { return Formatters.secondsToTimeConverterFilter(params); }, width: 150
                    },
                    {
                        headerName: "Loc HDOP", field: "GPSHDOP", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSHDOPTypeSorting(params.data.GPSHDOP, params.data.GPSLockState); }, cellRenderer: GensetCellRender.GPSfloatTypeValueFormatter, width: 130
                    },
                    {
                        headerName: "Loc sat ct", field: "GPSSatelliteCount", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.GPSSatCountTypeSorting(params.data.GPSSatelliteCount, params.data.GPSLockState); }, cellRenderer: GensetCellRender.GPSfloatTypeValueFormatter, width: 120
                    },
                    {
                        headerName: "MCC (country)", field: "CountryName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.CountryName); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "MNC", field: "MNC", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.MNC); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 70
                    },
                    {
                        headerName: "LAC", field: "TowerLocalizationAreaCode", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.TowerLocalizationAreaCode); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 70
                    },
                    {
                        headerName: "Tower ID", field: "TowerBaseStationID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.TowerBaseStationID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 130
                    },
                    {
                        headerName: "Device ID", field: "RCDID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.RCDID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "Device FW", field: "FirmwareVersion", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.FirmwareVersion); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 130
                    },
                    {
                        headerName: "Device bat (V)", field: "BattVoltage", enableRowGroup: true, cellClass: 'bigInt', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.BattVoltageSorting(params.data.BattVoltage); }, cellRenderer: Formatters.BattVoltageValueFormatter,
                        filterParams: { valueGetter: params => { return Formatters.DeviceBattVoltageFormatterForFilter(params); } }, width: 130
                    },
                    {
                        headerName: "MSISDN", field: "MSISDN", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.MSISDN); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 140
                    },
                    {
                        headerName: "IMSI", field: "SIM_IMSI", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.SIM_IMSI); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "ICCID", field: "ICCID", enableRowGroup: true, sortable: true, filter: true, resizable: true, cellClass: 'bigInt',
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ICCID); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "EUI", field: "EUI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.EUI); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 150
                    },
                    {
                        headerName: "Cell Signal", field: "RSSI", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return Formatters.RSSITypeFormatterFilter(params); } },
                        valueGetter: (params) => { return Formatters.RSSISorting(params); }, cellRenderer: GensetCellRender.RSSITypeFormatter, width: 80
                    },
                    {
                        headerName: "Speed", field: "Speed", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.floatTypeSorting(params.data.Speed); },
                        headerValueGetter: Formatters.SpeedHeaderFormatter, cellRenderer: GensetFormatters.gensetSpeedValueFormatter, width: 100
                    },
                    {
                        headerName: "Device config", field: "DeviceConfig", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        filterParams: { valueGetter: params => { return Formatters.GuestReeferModeFormatterForFilter(params); } },
                        cellRenderer: Formatters.GuestReeferModeFormatter, width: 120
                    },
                    {
                        headerName: "Device type", field: "DeviceType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, resizable: true, filter: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.DeviceType); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 120
                    },
                    {
                        headerName: "Receipt time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "CreatedDTTM", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true,
                        resizable: true, filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterCreatedDTTMForFilter(params); } },
                        cellRenderer: Formatters.dateTypeFormatter, width: 150
                    },
                    //{ headerName: "Comments", field: "CommentExistsGenset", cellRenderer: Formatters.stringTypeFormatter, width: 90 },
                    {
                        headerName: "Reporting (min)", field: "RCDReportingInterval", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                        valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.RCDReportingInterval); }, cellRenderer: GensetCellRender.stringTypeValueFormatter, width: 130
                    },
                    {
                        headerName: "Mfd. year", field: "ManufacturedDate", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, width: 80,
                        filterParams: { valueGetter: params => { return Formatters.YearFromdateTypeFormatterForFilter(params); } },
                        valueGetter: (params) => { return Formatters.ManufactureYearSorting(params); }, cellRenderer: Formatters.YearFromdateTypeFormatter
                    },
                    //{ headerName: "Profile", field: "Profile", width: 80, cellRenderer: Formatters.stringTypeFormatter },
                    //{ headerName: "Engine", field: "EngineType", width: 80, cellRenderer: Formatters.stringTypeFormatter },
                    //{ headerName: "Generator", field: "GeneratorType", width: 80, cellRenderer: Formatters.stringTypeFormatter },
                    //{ headerName: "ID Plate", field: "IdPlate", width: 80, cellRenderer: Formatters.stringTypeFormatter },
                    //{ headerName: "Assigned", field: "Assigned", width: 80, cellRenderer: Formatters.stringTypeFormatter }
                ]
            }
        ];
    }


    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    onGridSelectionChanged(params: any) {
        $("#contextmenu").show();
        var selectedGensetData = [];
        isMapEnable = self.props.mapEnabled;
        var selectedRows = params.api.getSelectedRows();

        if (selectedRows != null && selectedRows != undefined) {
            selectedRows.forEach(function (selectedRow, index) {
                selectedGensetData.push(selectedRow);
            });

            if (isMapEnable) {
                ReeferMap.UpdateIsLocationEstimated(false);
                self.BindMapPushPin(selectedRows);
            }

            self.setState({
                selectedDataItems: selectedRows
            });
        }

        self.setState({
            selectedItems: selectedGensetData,
            popUpHtml: '',
            modelTitle: ''
        });
    }

    BindMapPushPin(selectedRows: any) {
        var selectedRowsWithCoords = lodashfilter(selectedRows, function (item) {
            return item.GPSCoords != null && item.GPSCoords != undefined && item.GPSCoords.toString() != "";
        });
        if (selectedRowsWithCoords != null && selectedRowsWithCoords.length > 0)
            ReeferCallout.DisplayGensetSelectedPushpin(selectedRowsWithCoords[0]);
        else {
            if (self.state.rowData != null && self.state.rowData != undefined && self.state.rowData.length > 0) {
                var selectedRowIndex = self.state.rowData.findIndex(row => row.GensetHistoryID === selectedRows[0].GensetHistoryID);
                if (selectedRowIndex != -1) {
                    if (selectedRowIndex == self.state.rowData.length - 1) {
                        ReeferCallout.DisplayGensetSelectedPushpin(selectedRows[0]);
                    }
                    else {
                        for (var rowIndex = selectedRowIndex + 1; rowIndex < self.state.rowData.length; rowIndex++) {
                            var rowCurrentData = self.state.rowData[rowIndex];
                            if (rowCurrentData.GPSCoords != null && rowCurrentData.GPSCoords != undefined && rowCurrentData.GPSCoords.toString() != "") {
                                ReeferMap.UpdateIsLocationEstimated(true);
                                selectedRows[0].Latitude = rowCurrentData.Latitude;
                                selectedRows[0].Longitude = rowCurrentData.Longitude;
                                ReeferCallout.DisplayGensetSelectedPushpin(selectedRows[0]);
                                break;
                            }
                            else if (rowIndex == self.state.rowData.length - 1) {
                                ReeferCallout.DisplayGensetSelectedPushpin(selectedRows[0]);
                            }
                        }
                    }
                }
            }
        }
    }

    onPaginationPageLoaded(params: any) {
        var currentpage = params.api.paginationGetCurrentPage();
        var pagesize = params.api.paginationGetPageSize();
        var rowindex = pagesize * currentpage - 1;

        var rowNode = params.api.getRowNode(rowindex + 1);
        // do something with the row, eg select it
        if (rowNode != undefined && rowNode != null)
            rowNode.setSelected(true);
    }

    navigateToNextCell(params: any) {
        var previousCell = params.previousCellDef;
        var suggestedNextCell = params.nextCellDef;

        var KEY_UP = 38;
        var KEY_DOWN = 40;
        var KEY_LEFT = 37;
        var KEY_RIGHT = 39;

        switch (params.key) {
            case KEY_DOWN:
                previousCell = params.previousCellDef;
                // set selected cell on current cell + 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex + 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_UP:
                previousCell = params.previousCellDef;
                // set selected cell on current cell - 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex - 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_LEFT:
            case KEY_RIGHT:
                return suggestedNextCell;
            default:
                throw "this will never happen, navigation is always on of the 4 keys above";
        }
    }

    ValidateHistoryDates(filters: any) {
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var currentDttm = Formatters.DateTimeFormatter(currentUtcDttm);
        this.setState({ PreferenceDTTM: currentDttm });
        var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = filters.FromDate;
        var toDttm = filters.ToDate;

        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "From date should not be greater than current date.";

        if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
            return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }

    getGensetHistoryDetails() {
        isMapEnable = this.props.mapEnabled;
        var filters = this.state.Filters;
        var message = this.ValidateHistoryDates(filters);
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }
        else {
            this.setState({ Filters: filters });
        }

        self.state.gridApiParams.showLoadingOverlay();
        var fromDate = moment(new Date(filters.FromDate)).toString();
        var toDate = moment(new Date(filters.ToDate)).toString();
        filters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
        filters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
        var filterParams = JSON.stringify(filters);
        //if (this.state.reeferFormatter === null) {
        //    var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetReeferFormattersList', { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //    fetch(request)
        //        .then(RCUtils.handleError)
        //        .then(response => response.json() as Promise<server.ReeferFormatter>)
        //        .then(data => {
        //            this.setState({
        //                reeferFormatter: data
        //            }, () => {
        //                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //                fetch(request)
        //                    .then(RCUtils.handleError)
        //                    .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
        //                    .then(data => {
        //                        this.setState({
        //                            rowData: data
        //                        });

        //                        if (data.length > 0)
        //                            ReeferCallout.BindGensetTracePushpins(data, 'gensetTrace');

        //                        self.state.gridApiParams.hideOverlay();
        //                    });
        //            });
        //        });
        //}
        //else {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetHistoryDataSP', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.GensetHistoryUI[]>)
            .then(data => {
                this.setState({
                    rowData: data
                });

                if (data.length > 0 && isMapEnable) {
                    ReeferCallout.BindGensetTracePushpins(data, 'gensetTrace');
                    var dataArray = [];
                    if (self.state.selectedDataItems != null && self.state.selectedDataItems != undefined && self.state.selectedDataItems.length > 0)
                        dataArray.push(self.state.selectedDataItems[0]);
                    else
                        dataArray.push(data[0]);
                    self.BindMapPushPin(dataArray);
                }
                else
                    $('#globalLoader').hide();

                self.state.gridApiParams.hideOverlay();
            });
        //}
    }

    FromDateChange(date) {
        var filters = self.state.Filters;
        filters.FromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    ToDateChange(date) {
        var filters = self.state.Filters;
        filters.ToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    renderDateFields() {
        var currentDateFilters = this.state.Filters;
        if (currentDateFilters.ToDate != null && currentDateFilters.ToDate != undefined) {
            var currenttoDTTM = this.state.PreferenceDTTM;
            var toDTTM = DateFormat(new Date(currentDateFilters.ToDate), 'mm/dd/yyyy');
            var fromDTTM = DateFormat(new Date(currentDateFilters.FromDate), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(currenttoDTTM)).endOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
        else {
            var toDTTM = this.state.PreferenceDTTM;
            var modifiedDttm = new Date(toDTTM);
            modifiedDttm.setDate(modifiedDttm.getDate() - 1);
            var fromDTTM = DateFormat(new Date(modifiedDttm.toString()), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
    }

    renderEmailDialog(gridData: any, colDefs: any, colDefs2: any, formName: string, parentChild: string, functionId: any, widgetId: any, gridApiParams: any, isIncludeRowGroup: boolean, sensorData: any) {
        this.props.renderDataToEmailControl(gridData, colDefs, colDefs2, formName, parentChild, functionId, widgetId, gridApiParams, isIncludeRowGroup, gensetAssetSensors);
    }

    onGridScroll(params: any) {
        $(".gensetcontext-menu").hide();
        $("#gensetcontextmenu").hide();
    }

    renderGridPreferenceDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string) {
        this.props.renderDataGridPreferenceControl(functionId, widgetId, gridApiParams, formName);
    }

    renderExportToExcelDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any, sensorData: any) {
        this.props.renderDataGridExportToExcelControl(functionId, widgetId, gridApiParams, formName, gridData, colDefs, colDefs2, parentchild, gensetAssetSensors);
    }

    //renderSearchButton(isClickEnable: boolean) {
    //    if (isClickEnable)
    //        return <button id="btnReeferHistorySearch" type='button' onClick={this.getReeferHistoryDetails.bind(this)} className='btn btn-primary'>Search</button>;
    //    else
    //        return <button id="btnReeferHistorySearch" type='button' className='btn btn-primary'>Search</button>;
    //}
    openGensetMonitorGraph() {
        if (this.state.rowData.length > 0)
            this.props.openGensetMonitorGraph(this.state.rowData, this.state.Filters);
        else
            PopupWindow.showErrorMessage("Alert", "No data to draw graph");
    }
    onSavecolumnorder(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var ColumnValues = params.columnApi.getColumnState().map(col => col.colId);
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/GetCustomerInterfaceExportColumns?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null) {
                    rowGroupItems = currentGropup;
                    $.each(ColumnValues, function (index, value) {
                        var dataresult = data.filter(x => x.ColumnNm.trim().toUpperCase() == value.trim().toUpperCase());
                        if (dataresult.length > 0) {
                            selectedColumnIds.push(dataresult[0].InterfaceExportColumnId);
                            selectedColumnValues.push(dataresult[0].ColumnNm);
                        }
                    });
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
            });
    }
    onSaveGridRowGroupState(params) {
        if (!params.columnApi) return;
        var currentGropup = params.columnApi.getRowGroupColumns().map(c => c.colId);
        var colState = params.columnApi.getColumnState();
        var selectedColumnIds = [];
        var selectedColumnValues = [];
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = currentGropup;
                    selectedColumnIds = preferenceData.SelectedColumnIds;
                    selectedColumnValues = preferenceData.SelectedColumnValues;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(dataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });
                }
                else {
                    // if no userpreference record in db 
                    rowGroupItems = currentGropup;
                    var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
                    // var dataToSave = { SelectedColumnIds: selectedColumnIds, SelectedColumnValues: selectedColumnValues, SelectedRowGroups: rowGroupItems };
                    var rowGroupDataToSave = { colState: colState, SelectedRowGroups: rowGroupItems };
                    var preferencedata = { UserId: 0, FunctionId: functionId, PreferenceData: JSON.stringify(rowGroupDataToSave) };
                    var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleError)
                        .then(response => response.json())
                        .then(data => {
                            // save the row group data in background
                        });

                }
            });
        
        //var maxRowGroupLimit = 4;
        //var current = params.columns.length;

        //if (current === maxRowGroupLimit) {
        
        //    groupingDisabled = true;
        //    PopupWindow.showErrorMessage("RowGroup!", "max limit reached, please remove a group before adding a new one");
        
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: false };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
        //if (current < maxRowGroupLimit && groupingDisabled) {
        //    let colDefs = [];
        //    let cols = params.columnApi.getAllColumns();
        //    cols.forEach(col => {
        //        let newColDef = { ...col.colDef, enableRowGroup: true };
        //        colDefs.push(newColDef);
        //    });
        //    params.api.setColumnDefs(colDefs);
        //}
    }

    groupRowInnerRenderer(params) {

        var fieldName = params.node.field;
        var fieldValue = params.node.key;

        //var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        //var columnDisplayName = colDef[0].colDef.headerName;
        var colDef = params.node.rowGroupColumn.colDef;//WI 26719
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

        //if (fieldName.toString() == "EventDTTM" || fieldName.toString() == "DeviceDataTime" || fieldName.toString() == "CreatedDTTM")
        //    return Formatters.dateTypeFormatterGrouping(fieldValue);

        if (fieldValue == "-NA-" || (fieldValue == "-999" && self.validateFieldName(fieldName.toString().trim())))
            return "*No " + columnDisplayName;

        switch (fieldName.toString().trim()) {
            case "IgnitionOn":
                return GensetCellRender.GensetSwitchFormatterGrouping(fieldValue);
            case "GensetRunning":
                return GensetCellRender.EngineSortingFormatterGrouping(fieldValue);
            case "OEMTypeCD":
                return Formatters.OEMTypeFormatterGrouping(fieldValue);
            case "CustomerName":
                return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "*No Assigned To" : fieldValue;
            case "RSSI":
                return GensetCellRender.RSSIFormatterGrouping(fieldValue);
            //case "HasOilPressureSwitch":
            //    return Formatters.YesNoFormatterGrouping(fieldValue);
            case "FuelLevel":
                return Formatters.FuelLevelGalGrouping(fieldValue);
            case "FractionDisplay":
                return GensetCellRender.FillLevelTraceGrouping(fieldValue);
            case "HasFuelSensor":
                return Formatters.FuelSensorGrouping(fieldValue);
            case "ManufacturedDate":
                return fieldValue == 0 ? '*No Mfd. Year' : fieldValue;
            case "DeviceConfig":
                return Formatters.GuestReeferModeGrouping(fieldValue);
            case "EventDTTM":
            case "DeviceDataTime":
            case "CreatedDTTM":
                return Formatters.dateTypeGrouping(fieldValue, fieldName, params);
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGrouping(fieldValue, params);
            case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
            case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
            case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
            case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                return Formatters.SensorGrouping(fieldName.toString().trim(), fieldValue, gensetAssetSensors, colDef);
            case "AssetState":
                return GensetCellRender.AssetStateFormatterGrouping(fieldValue);
            default:
                return fieldValue
        }
    }

    validateFieldName(fieldName: any) {
        var IsValid = true;
        switch (fieldName) {
            case "Sensor1Value_GT1200": case "Sensor2Value_GT1200": case 'Sensor3Value_GT1200': case 'Sensor4Value_GT1200': case "Sensor5Value_GT1200": case "Sensor6Value_GT1200": case 'Sensor7Value_GT1200': case 'Sensor8Value_GT1200':
            case "Sensor1Value_GT1020": case "Sensor2Value_GT1020": case 'Sensor3Value_GT1020': case 'Sensor4Value_GT1020': case "Sensor5Value_GT1020": case "Sensor6Value_GT1020": case 'Sensor7Value_GT1020': case 'Sensor8Value_GT1020':
            case "Sensor1Value_ST9100": case "Sensor2Value_ST9100": case 'Sensor3Value_ST9100': case 'Sensor4Value_ST9100': case "Sensor5Value_ST9100": case "Sensor6Value_ST9100": case 'Sensor7Value_ST9100': case 'Sensor8Value_ST9100':
            case "Sensor1Value_GT1030": case "Sensor2Value_GT1030": case 'Sensor3Value_GT1030': case 'Sensor4Value_GT1030': case "Sensor5Value_GT1030": case "Sensor6Value_GT1030": case 'Sensor7Value_GT1030': case 'Sensor8Value_GT1030':
                { IsValid = false; }
                break;
        }
        return IsValid;
    }

    onFirstDataRendered(params) {
        var rowGroupItems = [];
        var url = Config.ApiBaseUrl + '/api/User/UserPreference?FunctionId=' + functionId;
        var request = RCUtils.FetchRequest(url);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.PreferenceData != null) {
                    var preferenceData = JSON.parse(data.PreferenceData);
                    rowGroupItems = preferenceData.SelectedRowGroups;
                    if (rowGroupItems != null && rowGroupItems != undefined && rowGroupItems.length > 0) {
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setRowGroupColumns(rowGroupItems);
                    }
                    if (preferenceData.colState != null && preferenceData.colState != undefined && preferenceData.colState.length > 0) {
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnState(preferenceData.colState);
                        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState({ state: preferenceData.colState, applyOrder: false, });
                        //self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.applyColumnState(preferenceData.colState);
                    }
                }
            });

    }

    getMainMenuItems(params) {
        let finalMenuItem = [];
        let itemsToExclude = "resetColumns";
        params.defaultItems.forEach(function (item) {
            if (itemsToExclude.indexOf(item) < 0) {
                finalMenuItem.push(item);
            }
        });
        finalMenuItem.push({
            name: 'Reset Columns',
            action: function () {
                self.setState({ gridApiParams: params.api });
                var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
                GridColumnPreferences.ResetGridColumns(functionId, params.api, "GensetHistoryGrid");
            },
        });
        return finalMenuItem;
    }

    onColumnResized = (params: any) => {
        console.log("column resized..");
        self.onSaveGridRowGroupState(params);
    }


    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];
        return <div>
            <div className='dashboard-GridToolbar'>
                <GridGensetHistoryToolBar
                    refreshGrid={this.refreshGrid.bind(this)}
                    gridData={this.state.rowData}
                    gridApiParams={this.state.gridApiParams}
                    colDefs={this.state.columnDefs}
                    colDefs2={columnDefs2}
                    parentchild={"C"}
                    formName={"GensetHistoryGrid"}
                    sourceFrom='Dashboard'
                    sensorData={gensetAssetSensors}
                    dashboardPreferenceId = {this.props.dashboardPreferenceId}
                    isReadOnly={this.props.isReadOnly}
                    revisionNum={this.props.revisionNum}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    validateRevisionNum={this.props.validateRevisionNum.bind(this)}
                    openGensetMonitorGraph={this.openGensetMonitorGraph.bind(this)}
                    renderEmailDialog={this.renderEmailDialog.bind(this)}
                    renderGridPreferenceDialog={this.renderGridPreferenceDialog.bind(this)}
                    renderExportToExcelDialog={this.renderExportToExcelDialog.bind(this)}
                />
            </div>

            <div className="widget-calender">

                <div className="input-group from-to-calender">
                    <span className="input-group-text">From</span>
                    <DatePicker
                        selected={new Date(this.state.Filters.FromDate)}
                        maxDate={new Date(this.state.PreferenceDTTM)}
                        onChange={this.FromDateChange.bind(this)}
                        timeInputLabel="Time:"
                        showYearDropdown
                        yearDropdownItemNumber={5}
                        dateFormat="MM/dd/yyyy hh:mm aa"
                        showTimeInput  
                        className=""                          
                    />
                    <span className="input-group-text">To</span>
                    <DatePicker
                        selected={new Date(this.state.Filters.ToDate)}
                        maxDate={new Date(this.state.PreferenceDTTM)}
                        onChange={this.ToDateChange.bind(this)}
                        timeInputLabel="Time:"
                        showYearDropdown
                        yearDropdownItemNumber={5}
                        dateFormat="MM/dd/yyyy hh:mm aa"
                        showTimeInput
                        className=""    
                    />

                    {
                        this.state.buttonState == true ?
                            <button type='button' onClick={this.getGensetHistoryDetails.bind(this)} className='btn btn-primary'>Search</button>
                            :
                            <button type='button' disabled={this.state.buttonState == false} className='btn btn-primary'>Search</button>
                    }

                </div>

            </div>

            <div className="ag-theme-fresh Dashboard-ReeferHistoryGrid-height">
                <AgGridReact
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    animateRows={true}
                    rowGroupPanelShow={this.state.rowGroupPanelShow}
                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                    onColumnRowGroupChanged={this.onSaveGridRowGroupState.bind(this)}
                    onDragStopped={this.onSavecolumnorder.bind(this)}
                    onColumnPinned={this.onSaveGridRowGroupState.bind(this)}
                    onColumnResized={Formatters.debounce(this.onColumnResized, 1000)}
                    groupRowRendererParams={groupRowRendererParams}
                    getMainMenuItems={this.getMainMenuItems.bind(this)}
                    //groupRowInnerRenderer={this.groupRowInnerRenderer}
                    defaultGroupOrderComparator={
                        function (nodeA, nodeB) {
                            var AnodeIsNumber = Number(nodeA.key);
                            var BnodeIsNumber = Number(nodeB.key);
                            var AnodeIsString = String(nodeA.key);
                            var BnodeIsString = String(nodeB.key);

                            if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                return AnodeIsNumber - BnodeIsNumber;
                            } else {
                                return AnodeIsString.localeCompare(BnodeIsString);
                            }
                        }
                    }
                    groupDisplayType='groupRows'
                    pagination={true}
                    paginationPageSize={this.state.pageSize}
                    excelStyles={excelStyles}
                    rowSelection={'multiple'}
                    accentedSort={true}
                    rowDeselection={true}
                    onSelectionChanged={this.onGridSelectionChanged}
                    onPaginationChanged={this.onPaginationPageLoaded}
                    navigateToNextCell={this.navigateToNextCell}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}
                    processCellForClipboard={this.ProcessCellForClipboard}
                    enableRangeSelection={true}
                    allowContextMenuWithControlKey={true}
                    getContextMenuItems={this.getGensetHistoryContextMenuItems}
                    onBodyScroll={this.onGridScroll}>
                </AgGridReact>
            </div>
            <div className='pageSize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                </select>
            </div>
        </div>;
    }
}

class GensetHistoryFilter {
    AssetNumber: string;
    DeviceNumber: string;
    FromDate: string;
    ToDate: string;
    EventCode: string;
}
